import _ from 'lodash';
import en from './locale/en_US';
import zh from './locale/zh_CN';

const tools = {
  getToken() {
    const $token = document.getElementsByName('_tb_token_');
    return $token.length ? $token[0].value : '';
  },
  isDaily() {
    const host = window.location.host;
    return host.indexOf('daily') > -1;
  },
  copyToClipboard(string) {
    const parentDom = document.createElement('div');
    const textarea = document.createElement('textarea');
    textarea.value = string;
    parentDom.appendChild(textarea);
    document.body.appendChild(parentDom);
    textarea.select();
    document.execCommand('copy');
    parentDom.removeChild(textarea);
  },

  getQueryString(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, 'i');
    const r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  },

  urlToObj(str) {
    if (!str) {
      return {};
    }
    const pairs = str.substring(1).split('&');
    const obj = {};

    for (const i in pairs) {
      if (pairs[i] && pairs[i] !== '' && (typeof pairs[i]) === 'string') {
        const pair = pairs[i].split('=');
        obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
      }
    }
    return obj;
  },

  objToUrl(obj) {
    if (Object.keys(obj).length === 0) {
      return '';
    }
    const str = [];
    for (const k in obj) {
      str.push(`${k}=${obj[k]}`);
    }
    return str.join('&');
  },

  getUrlParam(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = decodeURIComponent(
      (window.location.search + window.location.hash).substr(1)
    ).match(reg);
    if (r !== null) return unescape(r[2]);
    return '';
  },

  getParams() {
    return this.extend(
      this.urlToObj(window.location.search),
      this.urlToObj(window.location.hash)
    );
  },

  setSearch(key, value) {
    const searchObj = this.urlToObj(window.location.search);
    searchObj[key] = value;
    window.location.search = this.objToUrl(searchObj);
  },

  setHash(key, value) {
    const hashObj = this.urlToObj(window.location.hash);
    hashObj[key] = value;
    window.location.hash = this.objToUrl(hashObj);
  },
  isArray(object) {
    return object instanceof Array;
  },
  isWindow(obj) {
    return obj != null && obj == obj.window;
  },
  isDocument(obj) {
    return obj != null && obj.nodeType == obj.DOCUMENT_NODE;
  },
  isObject(obj) {
    return this._type(obj) == 'object';
  },
  isFunction(fn) {
    return this._type(fn) == 'function';
  },
  isPlainObject(obj) {
    return this.isObject(obj) && !this.isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype;
  },
  _type(obj) {
    const class2type = {};
    const toString = class2type.toString;
    return obj == null ? String(obj) :
      class2type[toString.call(obj)] || 'object';
  },
  isString(str) {
    return typeof str === 'string';
  },
  extend(target = {}, source = {}) {
    const result = {};
    for (const key in source) {
      if (source[key]) {
        result[key] = source[key];
      }
    }
    for (const key in target) {
      if (target[key]) {
        result[key] = target[key];
      }
    }
    return result;
  },
  namespace(name) {
    return function (v) {
      return `${name}-${v}`;
    };
  },
  getIconMap(stamp) {
    const stampIconMap = {
      Req: 'bookmark',
      Task: 'tasks',
      Bug: 'bug',
      Risk: 'exclamation-triangle',
    };
    if (!stamp) {
      stamp = 'Req';
    }
    return stampIconMap[stamp] ? stampIconMap[stamp] : 'bookmark';
  },
};

export const NameSpace = tools.namespace.bind(tools);
export default tools;

export const FIELD_FORMAT_MAP = {
  string: '文本',
  text: '长段文本',
  int: '整数',
  float: '浮点数',
  list: '单选列表',
  multiList: '多选列表',
  dynamicList: '动态单选列表',
  dynamicMultiList: '动态多选列表',
  date: '日期',
  bool: '布尔型',
  keyword: '模糊搜索',
  'int~object': '对象',
};

export function cs(...classNames) {
  return _.filter(classNames).join(' ');
}

export function formateToDateTime(time) {
  const timeStamp = Date.parse(time);
  const date = new Date(timeStamp);
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth();
  const day = date.getUTCDate();
  const hour = date.getUTCHours();
  const minute = date.getUTCMinutes();
  const second = date.getUTCSeconds();
  return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
}


export function formateToDate(time) {
  const timeStamp = Date.parse(time);
  const date = new Date(timeStamp);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}-${month}-${day}`;
}

function checkTime(i) {
  if (i < 10) {
    i = `0${i}`;
  }
  return i;
}


export function formateTimeStampToDate(timeStamp) {
  const date = new Date(timeStamp);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}-${checkTime(month)}-${checkTime(day)}`;
}

export function formateToDateByTimeStamp(timeStamp) {
  const date = new Date(timeStamp);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();
  return `${year}-${month}-${day} ${checkTime(hour)}:${checkTime(minute)}:${checkTime(second)}`;
}

export function formateToDayByTimeStamp(timeStamp) {
  const date = new Date(timeStamp);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}-${checkTime(month)}-${checkTime(day)}`;
}
export function dateAdd(interval, number, date) {
  /*
    *   功能:实现VBScript的DateAdd功能.
    *   参数:interval,字符串表达式，表示要添加的时间间隔.
    *   参数:number,数值表达式，表示要添加的时间间隔的个数.
    *   参数:date,时间对象.
    *   返回:新的时间对象.
    *   var   now   =   new   Date();
    *   var   newDate   =   DateAdd( "d ",5,now);
    *---------------   DateAdd(interval,number,date)   -----------------
    */
  number = parseInt(number);
  const year = parseInt(date.getFullYear());
  const month = parseInt(date.getMonth());
  const day = parseInt(date.getDate());
  const hour = parseInt(date.getHours());
  const minute = parseInt(date.getMinutes());
  const second = parseInt(date.getSeconds());

  switch (interval) {
    case 'year' : {
      date.setFullYear(year + number);
      return date;
    }
    case 'month' : {
      const newMonth = month + number;
      date.setMonth(newMonth);
      return date;
    }
    case 'week' : {
      date.setDate(day + (number * 7));
      return date;
    }
    case 'day' : {
      date.setDate(day + number);
      return date;
    }
    case 'hour' : {
      date.setHours(hour + number);
      return date;
    }
    case 'miute' : {
      date.setMinutes(minute + number);
      return date;
    }
    case 'second' : {
      date.setSeconds(second + number);
      return date;
    }
    default : {
      date.setDate(day + number);
      return date;
    }
  }
}

export function i18n(...lang) {
  const isEn = /ak_user_locale=en_US/.test(document.cookie);
  if (lang.length === 1) {
    if (isEn) {
      return en[lang[0]] || '';
    }
    return zh[lang[0]] || '';
  } else if (isEn) {
    return lang[1] || '';
  }
  return lang[0] || '';
}

// define remove function
function removeElements(elms) {
  Array.from(elms).forEach(el => el.remove());
}

export function aoneNav(opts) {
  const el = document.querySelector('.aone-nav ');
  const ifUseAkProjectApi = window.AK_GLOBAL && window.AK_GLOBAL.renderBy && window.AK_GLOBAL.renderBy === 'ak-project';
  if (ifUseAkProjectApi) {
    return;
  }
  const params = Object.assign({
    type: 'ajax',
    ajax: {
      url: '/api/anonymous/getProjectNavs',
      dataType: 'jsonp',
      data: {
        staffId: window.AK_GLOBAL.keludeUser.staffId,
        key: opts.key,
        projectId: window.AK_GLOBAL.projectId
      },
      success: () => {
        if (el) {
          removeElements(document.querySelectorAll('.aone-nav'));
        }
      },
      format: data => data.result
    }
  }, opts);
  window.aoneLayout.aoneNav(params);
  return true;
}

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

export function getLocale() {
  const locale = getCookie('ak_user_locale');
  if (locale === 'en_US') {
    return 'en-us';
  }
  return 'zh-cn';
}

export function isPrivateCloud() {
 return window.AK_GLOBAL.siteType === 'vpc';
}

export function calculateDateGap(date) {
  const today = formateTimeStampToDate(new Date());
  const dateTimeStamp = new Date(date);
  const todayTimeStamp = new Date(today);
  return (dateTimeStamp - todayTimeStamp) / (24 * 60 * 60 * 1000);
}



/** WEBPACK FOOTER **
 ** ./src/utils/index.js
 **/